import { styled } from '@linaria/react';
const Modal = /*#__PURE__*/styled('div')({
  name: "Modal",
  class: "m1v8ynxa",
  propsAsIs: false
});
const Backdrop = /*#__PURE__*/styled('div')({
  name: "Backdrop",
  class: "b1cra969",
  propsAsIs: false
});
const StyledPopup = /*#__PURE__*/styled('div')({
  name: "StyledPopup",
  class: "s1nreq4i",
  propsAsIs: false
});
const StyledHeader = /*#__PURE__*/styled('div')({
  name: "StyledHeader",
  class: "sckdgas",
  propsAsIs: false
});
const _exp27 = /*#__PURE__*/() => ({
  position
}) => position.justifyContent;
const StyledButtonGroup = /*#__PURE__*/styled('div')({
  name: "StyledButtonGroup",
  class: "s3tute5",
  propsAsIs: false,
  vars: {
    "s3tute5-0": [_exp27()]
  }
});
const buttonClass = "b1criwri";
// We need to use !important to override the body scroll
const preventBodyScrollClass = "p116qbki";
const CloseButton = /*#__PURE__*/styled('button')({
  name: "CloseButton",
  class: "c1r537fh",
  propsAsIs: false
});
const OptionButton = /*#__PURE__*/styled('button')({
  name: "OptionButton",
  class: "oux9sl5",
  propsAsIs: false
});
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "c17li4qn",
  propsAsIs: false
});
const ChildrenContent = /*#__PURE__*/styled('div')({
  name: "ChildrenContent",
  class: "cid5w6x",
  propsAsIs: false
});
// To visible children inside children wrapper in overflow-y case
const showChildrenOverflowClass = "s1vq0rkp";
const HeaderTopBar = /*#__PURE__*/styled('div')({
  name: "HeaderTopBar",
  class: "ha1bn5q",
  propsAsIs: false
});
const noSpacingClass = "n1lgl3yo";
export { Modal, StyledPopup, CloseButton, OptionButton, StyledHeader, ChildrenWrapper, ChildrenContent, StyledButtonGroup, Backdrop, buttonClass, showChildrenOverflowClass, HeaderTopBar, noSpacingClass, preventBodyScrollClass };

require("./Drawer.styles.linaria.module.css");